export default "__VITE_PUBLIC_ASSET__3ddf42d4__"